var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskForTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 215,
    viewBox: "0 0 261 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3565_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20215 115.451C3.20215 136.631 21.598 153.8 44.2904 153.8C66.9828 153.8 85.3787 136.631 85.3787 115.451C85.3787 94.2713 66.9828 77.1019 44.2904 77.1019C21.598 77.1019 3.20215 94.2713 3.20215 115.451Z",
    fill: "url(#paint0_linear_3565_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6384 72.8467H44.7981H41.5513V78.3194H47.6384V72.8467Z",
    fill: "url(#paint1_linear_3565_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1399 74.4936C40.1376 74.4936 36.8931 71.2491 36.8931 67.2468C36.8931 63.2445 40.1376 60 44.1399 60C48.1422 60 51.3867 63.2445 51.3867 67.2468C51.3867 71.2491 48.1422 74.4936 44.1399 74.4936Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8101 156.844C19.6144 156.844 0 138.532 0 115.942C0 102.339 7.113 90.287 18.0562 82.851C19.163 82.0989 20.4837 81.7402 21.8219 81.7402H65.7984C67.1365 81.7402 68.4573 82.0989 69.5641 82.851C80.5072 90.287 87.6202 102.339 87.6202 115.942C87.6202 138.532 68.0058 156.844 43.8101 156.844Z",
    fill: "url(#paint2_linear_3565_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4772 148.275C68.1148 146.914 69.0802 143.739 71.6336 141.184C74.1869 138.63 77.3612 137.663 78.7236 139.025C80.086 140.387 79.1205 143.561 76.5672 146.116C74.0139 148.67 70.8395 149.637 69.4772 148.275Z",
    fill: "#236DC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7907 150.155C65.0032 148.341 66.4957 143.972 70.1243 140.397C73.7528 136.822 78.1434 135.395 79.9309 137.209C81.7184 139.023 80.2259 143.392 76.5974 146.967C72.9688 150.542 68.5782 151.969 66.7907 150.155ZM69.908 147.829C68.7707 146.674 69.7203 143.895 72.0291 141.62C74.338 139.345 77.1316 138.437 78.269 139.591C79.4064 140.746 78.4567 143.526 76.1479 145.8C73.8391 148.075 71.0454 148.983 69.908 147.829Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3368 145.184L69.2993 142.596L74.4757 138.521L76.5132 141.109L71.3368 145.184ZM89.3179 141.61C90.1669 140.001 92.1589 139.385 93.7679 140.233C95.3769 141.082 95.9939 143.075 95.1449 144.684L89.3179 141.61ZM76.5132 141.109C78.3224 143.408 79.6496 144.321 80.4874 144.729C81.3805 145.165 81.8225 145.145 82.9953 145.379L81.7033 151.839C81.2291 151.744 79.4903 151.573 77.5987 150.65C75.6517 149.7 73.5903 148.047 71.3368 145.184L76.5132 141.109ZM82.9953 145.379C82.8301 145.346 83.052 145.416 83.819 145.178C84.4919 144.969 85.3071 144.61 86.1451 144.138C86.9789 143.668 87.7539 143.133 88.3589 142.618C88.6609 142.361 88.8959 142.131 89.0669 141.937C89.1519 141.841 89.2139 141.763 89.2569 141.703C89.2779 141.673 89.2929 141.65 89.3039 141.634C89.3139 141.617 89.3179 141.609 89.3179 141.61L95.1449 144.684C94.5309 145.848 93.5469 146.854 92.6279 147.636C91.6599 148.459 90.5289 149.23 89.3789 149.878C88.2329 150.523 86.9859 151.094 85.7703 151.47C84.6488 151.818 83.1563 152.13 81.7033 151.839L82.9953 145.379Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3621 145.216L69.2935 142.652L74.4205 138.515L76.489 141.078L71.3621 145.216ZM88.8619 140.425C89.5609 138.746 91.4899 137.952 93.1689 138.651C94.8489 139.351 95.6429 141.28 94.9429 142.959L88.8619 140.425ZM94.9429 142.959C94.7759 143.36 94.5829 143.747 94.3719 144.117L88.6459 140.86C88.7359 140.702 88.8069 140.556 88.8619 140.425L94.9429 142.959ZM80.7822 151.753C80.2733 151.682 79.7576 151.561 79.2475 151.376L81.4989 145.184C81.5355 145.198 81.5964 145.215 81.688 145.228L80.7822 151.753ZM79.2475 151.376C79.0858 151.317 78.9355 151.264 78.7953 151.215L80.9388 144.986C81.1141 145.046 81.3004 145.112 81.4989 145.184L79.2475 151.376ZM71.6919 145.625C71.5862 145.494 71.4763 145.357 71.3621 145.216L76.489 141.078C76.6073 141.225 76.7209 141.366 76.8302 141.502L71.6919 145.625Z",
    fill: "#0F4688"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.061 144.465C67.7606 143.111 68.8002 141.7 70.1242 140.396C72.1774 138.373 74.4746 137.039 76.4062 136.589L75.5911 139.319C74.4612 139.685 73.1844 140.481 72.029 141.619C71.1026 142.532 70.395 143.527 69.9533 144.465H67.061Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9356 143.469C87.609 141.5 86.5088 137.207 88.4782 133.88C90.4476 130.553 94.7409 129.453 98.0675 131.423C101.394 133.392 102.494 137.685 100.525 141.012C98.5555 144.338 94.2622 145.439 90.9356 143.469Z",
    fill: "#85B7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.639 147.617C26.0014 146.255 25.036 143.08 22.4826 140.526C19.9293 137.971 16.755 137.004 15.3926 138.366C14.0302 139.728 14.9957 142.903 17.549 145.457C20.1023 148.012 23.2767 148.979 24.639 147.617Z",
    fill: "#236DC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3264 149.497C29.1139 147.683 27.6214 143.314 23.9928 139.739C20.3643 136.164 15.9737 134.736 14.1862 136.551C12.3987 138.365 13.8912 142.734 17.5197 146.309C21.1483 149.884 25.5389 151.311 27.3264 149.497ZM24.2091 147.171C25.3464 146.016 24.3968 143.236 22.088 140.962C19.7792 138.687 16.9855 137.779 15.8481 138.933C14.7107 140.088 15.6604 142.867 17.9692 145.142C20.278 147.417 23.0717 148.325 24.2091 147.171Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7793 144.526L24.8169 141.938L19.6404 137.863L17.6029 140.451L22.7793 144.526ZM14.1825 162.347C15.8716 163.022 17.7886 162.201 18.4642 160.511C19.1399 158.822 18.3183 156.905 16.6292 156.23L14.1825 162.347ZM17.6029 140.451C15.8103 142.728 14.1282 144.09 12.4216 145.529C10.7375 146.948 8.83641 148.588 7.51771 151.229L13.4117 154.172C14.0668 152.86 14.9976 151.974 16.6676 150.566C18.3151 149.177 20.5093 147.41 22.7793 144.526L17.6029 140.451ZM7.51771 151.229C6.66681 152.933 6.36001 154.739 6.86971 156.499C7.36231 158.199 8.47611 159.36 9.47741 160.111C11.2595 161.448 13.8977 162.233 14.1825 162.347L16.6292 156.23C16.342 156.115 15.9834 155.991 15.7227 155.899C15.4244 155.794 15.1328 155.689 14.8388 155.571C14.2268 155.326 13.7519 155.082 13.4308 154.841C13.1148 154.604 13.1582 154.53 13.1976 154.666C13.2541 154.861 13.1112 154.774 13.4117 154.172L7.51771 151.229Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7796 144.526L24.8171 141.938L19.6407 137.863L17.6032 140.451L22.7796 144.526ZM14.4141 162.429C16.1489 162.977 17.9993 162.015 18.5471 160.28C19.0949 158.545 18.1326 156.695 16.3978 156.147L14.4141 162.429ZM16.3978 156.147C16.189 156.081 15.9903 156.016 15.8011 155.952L13.689 162.192C13.924 162.272 14.1657 162.351 14.4141 162.429L16.3978 156.147ZM13.8023 153.599C13.8835 153.426 13.9727 153.242 14.0705 153.046L8.17688 150.102C8.06038 150.336 7.94688 150.568 7.83838 150.8L13.8023 153.599ZM14.0705 153.046C14.1575 152.872 14.2445 152.715 14.3312 152.572L8.69538 149.16C8.51378 149.46 8.34108 149.774 8.17688 150.102L14.0705 153.046ZM22.2031 145.236C22.394 145.008 22.5862 144.772 22.7796 144.526L17.6032 140.451C17.4519 140.643 17.303 140.826 17.1566 141.001L22.2031 145.236Z",
    fill: "#0F4688"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0561 143.806C26.3565 142.453 25.3169 141.043 23.9929 139.739C21.9397 137.716 19.6425 136.38 17.7109 135.931L18.526 138.661C19.6559 139.027 20.9327 139.823 22.0881 140.962C23.0145 141.874 23.7221 142.869 24.1638 143.806H27.0561Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7686 167.845C11.442 165.876 10.3418 161.583 12.3112 158.256C14.2806 154.929 18.5739 153.829 21.9005 155.799C25.2271 157.768 26.3273 162.061 24.3579 165.388C22.3885 168.714 18.0952 169.815 14.7686 167.845Z",
    fill: "#86B8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4385 141.328H57.4385C57.7114 141.328 57.9326 141.549 57.9326 141.822V147.751C57.9326 148.024 57.7114 148.245 57.4385 148.245C57.1656 148.245 56.9444 148.024 56.9444 147.751V141.822C56.9444 141.549 57.1656 141.328 57.4385 141.328Z",
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5098 141.328H51.5098C51.7827 141.328 52.0039 141.549 52.0039 141.822V147.751C52.0039 148.024 51.7827 148.245 51.5098 148.245C51.2369 148.245 51.0157 148.024 51.0157 147.751V141.822C51.0157 141.549 51.2369 141.328 51.5098 141.328Z",
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4737 139.351H54.4737C54.7466 139.351 54.9678 139.572 54.9678 139.845V150.715C54.9678 150.988 54.7466 151.209 54.4737 151.209C54.2008 151.209 53.9796 150.988 53.9796 150.715V139.845C53.9796 139.572 54.2008 139.351 54.4737 139.351Z",
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8624 91.9229H71.0963C81.4659 91.9229 89.8721 100.329 89.8721 110.699C89.8721 121.068 81.4659 129.474 71.0963 129.474H34.8624C24.4928 129.474 16.0866 121.068 16.0866 110.699C16.0866 100.329 24.4928 91.9229 34.8624 91.9229Z",
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 2.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1646 110.369C66.1646 109.417 66.3519 108.475 66.7161 107.596C67.0803 106.716 67.6141 105.918 68.287 105.245C68.9599 104.572 69.7588 104.038 70.638 103.674C71.5173 103.31 72.4596 103.122 73.4113 103.122C74.3629 103.122 75.3053 103.31 76.1845 103.674C77.0637 104.038 77.8626 104.572 78.5355 105.245C79.2085 105.918 79.7422 106.716 80.1064 107.596C80.4706 108.475 80.6581 109.417 80.6581 110.369",
    stroke: "#72B2FF",
    strokeWidth: 3.73136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2251 110.369C33.2251 109.417 33.4126 108.475 33.7768 107.596C34.1409 106.716 34.6747 105.918 35.3477 105.245C36.0206 104.572 36.8195 104.038 37.6987 103.674C38.5779 103.31 39.5203 103.122 40.4719 103.122C41.4236 103.122 42.3659 103.31 43.2451 103.674C44.1244 104.038 44.9232 104.572 45.5962 105.245C46.2691 105.918 46.8029 106.716 47.1671 107.596C47.5313 108.475 47.7187 109.417 47.7187 110.369",
    stroke: "#72B2FF",
    strokeWidth: 3.73136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0834 135.384L32.5325 131.933C30.3572 131.054 27.8819 132.106 27.0037 134.281L17.1751 158.629C16.297 160.804 17.3486 163.279 19.5239 164.157L28.0748 167.609C30.2501 168.487 32.7254 167.436 33.6035 165.261L43.4322 140.913C44.3103 138.738 43.2587 136.263 41.0834 135.384Z",
    fill: "#FF9154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.833 140.889C40.7163 140.959 41.489 140.299 41.559 139.416C41.629 138.533 40.9697 137.76 40.0865 137.69C39.2033 137.62 38.4306 138.28 38.3606 139.163C38.2906 140.046 38.9498 140.819 39.833 140.889Z",
    fill: "#F56414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.759 103C255.759 137.794 225.538 166 188.259 166C150.98 166 120.759 137.794 120.759 103C120.759 68.2061 150.98 40 188.259 40C225.538 40 255.759 68.2061 255.759 103Z",
    fill: "url(#paint3_linear_3565_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.759 26H192.759V42H182.759V26Z",
    fill: "url(#paint4_linear_3565_553)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.759,
    cy: 14,
    r: 14,
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.759 171C228.523 171 260.759 141.003 260.759 104C260.759 81.6271 248.974 61.8154 230.867 49.6466C229.185 48.5167 227.187 47.9738 225.161 47.9738H152.357C150.331 47.9738 148.332 48.5167 146.651 49.6466C128.543 61.8154 116.759 81.6271 116.759 104C116.759 141.003 148.994 171 188.759 171Z",
    fill: "url(#paint5_linear_3565_553)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.521,
    cy: 146.972,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 137.521 146.972)",
    fill: "#236DC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.617 156.846C151.331 154.092 149.065 147.461 143.557 142.034C138.05 136.608 131.385 134.441 128.672 137.195C125.959 139.949 128.224 146.581 133.732 152.007C139.24 157.434 145.904 159.6 148.617 156.846ZM143.886 153.316C145.612 151.563 144.171 147.344 140.666 143.891C137.161 140.438 132.921 139.059 131.194 140.812C129.468 142.564 130.909 146.784 134.414 150.236C137.919 153.689 142.159 155.068 143.886 153.316Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.186 149.876L144.854 146.477L138.056 139.143L134.389 142.542L141.186 149.876ZM114 140.5L118.144 137.703L114 140.5ZM118.243 114.081C119.117 111.461 117.701 108.63 115.081 107.757C112.461 106.883 109.63 108.299 108.757 110.919L118.243 114.081ZM134.389 142.542C131.889 144.859 129.43 145.54 127.186 145.12C124.818 144.676 121.582 142.796 118.144 137.703L109.856 143.297C114.195 149.726 119.46 153.846 125.344 154.949C131.353 156.075 136.899 153.85 141.186 149.876L134.389 142.542ZM118.144 137.703C115.95 134.452 115.046 132.913 114.838 130.399C114.601 127.542 115.272 122.994 118.243 114.081L108.757 110.919C105.727 120.006 104.456 126.208 104.872 131.226C105.316 136.587 107.663 140.048 109.856 143.297L118.144 137.703Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.53 149.524L144.845 145.781L137.359 139.151L134.044 142.893L141.53 149.524ZM113 139L108.915 141.883L113 139ZM117.889 116.048C118.467 113.347 116.747 110.69 114.047 110.111C111.347 109.532 108.689 111.252 108.111 113.952L117.889 116.048ZM108.111 113.952C108.056 114.205 108.002 114.454 107.948 114.698L117.712 116.86C117.771 116.594 117.83 116.323 117.889 116.048L108.111 113.952ZM105.241 125.324C105.098 125.927 104.968 126.533 104.859 127.139L114.703 128.9C114.771 128.521 114.86 128.101 114.973 127.623L105.241 125.324ZM108.412 141.158C108.575 141.397 108.742 141.639 108.915 141.883L117.085 136.117C116.944 135.917 116.81 135.725 116.684 135.538L108.412 141.158ZM108.915 141.883C109.118 142.171 109.324 142.456 109.532 142.739L117.579 136.801C117.412 136.576 117.248 136.347 117.085 136.117L108.915 141.883ZM120.886 153.133C121.612 153.52 122.36 153.869 123.127 154.171L126.789 144.865C126.403 144.714 126.003 144.529 125.588 144.308L120.886 153.133ZM140.684 150.426C140.972 150.137 141.253 149.836 141.53 149.524L134.044 142.893C133.89 143.068 133.737 143.23 133.588 143.38L140.684 150.426Z",
    fill: "#0F4688"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.207 148.209C147.145 146.155 145.567 144.014 143.557 142.034C140.441 138.964 136.954 136.937 134.022 136.255L135.259 140.398C136.974 140.954 138.912 142.163 140.666 143.891C142.072 145.276 143.146 146.785 143.817 148.209H148.207Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.556,
    cy: 108.556,
    r: 10.625,
    transform: "rotate(-30.6263 115.556 108.556)",
    fill: "#85B7F2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 249.765 143.694)",
    fill: "#236DC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.906 156.846C225.193 154.093 227.458 147.461 232.966 142.034C238.474 136.608 245.138 134.441 247.852 137.195C250.565 139.949 248.299 146.581 242.792 152.007C237.284 157.434 230.619 159.6 227.906 156.846ZM232.638 153.316C230.911 151.563 232.353 147.344 235.857 143.891C239.362 140.438 243.603 139.059 245.329 140.812C247.055 142.564 245.614 146.784 242.109 150.237C238.605 153.689 234.364 155.068 232.638 153.316Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.808 149.302L231.715 145.373L239.572 139.187L242.665 143.116L234.808 149.302ZM240.593 207.642C238.03 208.668 235.12 207.421 234.094 204.857C233.069 202.293 234.316 199.383 236.88 198.358L240.593 207.642ZM242.665 143.116C246.433 147.903 248.703 154.535 250.053 160.406C251.427 166.379 252 172.244 252 176L242 176C242 173.049 241.524 167.936 240.308 162.648C239.068 157.259 237.206 152.348 234.808 149.302L242.665 143.116ZM252 176C252 180.063 250.345 187.197 248.593 193.007C247.685 196.015 246.668 198.945 245.674 201.252C245.184 202.39 244.642 203.511 244.062 204.45C243.773 204.917 243.406 205.451 242.956 205.95C242.568 206.381 241.786 207.165 240.593 207.642L236.88 198.358C235.999 198.71 235.556 199.224 235.526 199.257C235.436 199.358 235.449 199.364 235.557 199.189C235.77 198.845 236.089 198.227 236.49 197.295C237.28 195.462 238.173 192.923 239.019 190.119C240.773 184.303 242 178.437 242 176L252 176Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.807 149.302L231.715 145.373L239.572 139.187L242.665 143.116L234.807 149.302ZM247 175L242 175L247 175ZM243.919 203.839C242.627 206.28 239.601 207.211 237.161 205.919C234.72 204.627 233.789 201.601 235.081 199.16L243.919 203.839ZM235.081 199.16C235.202 198.932 235.323 198.699 235.442 198.464L244.356 202.996C244.212 203.279 244.067 203.561 243.919 203.839L235.081 199.16ZM239.586 188C239.745 187.479 239.897 186.959 240.042 186.442L249.67 189.143C249.505 189.732 249.332 190.323 249.152 190.915L239.586 188ZM241.987 175.68C241.996 175.44 242 175.213 242 175L252 175C252 175.345 251.993 175.694 251.98 176.048L241.987 175.68ZM242 175C242 174.746 241.996 174.474 241.989 174.185L251.986 173.925C251.995 174.295 252 174.653 252 175L242 175ZM240.292 162.082C240.155 161.518 240.009 160.954 239.854 160.392L249.494 157.734C249.677 158.398 249.849 159.062 250.009 159.722L240.292 162.082ZM235.247 149.886C235.102 149.684 234.955 149.489 234.807 149.302L242.665 143.116C242.906 143.422 243.14 143.733 243.367 144.049L235.247 149.886Z",
    fill: "#0F4688"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.316 148.209C229.378 146.155 230.956 144.014 232.966 142.034C236.083 138.964 239.57 136.937 242.502 136.255L241.264 140.398C239.549 140.955 237.611 142.163 235.857 143.891C234.451 145.276 233.377 146.785 232.707 148.209H228.316Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.556,
    cy: 204.556,
    r: 10.625,
    transform: "rotate(-30.6263 235.556 204.556)",
    fill: "#86B8F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 149,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 149,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.5,
    y: 146,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 60,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 80.5,
    r: 8.5,
    fill: "#72B2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 80.5,
    r: 8.5,
    fill: "#72B2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3565_553",
    x1: 44.2904,
    y1: 68.5799,
    x2: 44.2904,
    y2: 153.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3565_553",
    x1: 44.2905,
    y1: 68.58,
    x2: 44.2905,
    y2: 153.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3565_553",
    x1: 43.8101,
    y1: 75.0411,
    x2: 43.8101,
    y2: 156.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3565_553",
    x1: 188.259,
    y1: 26,
    x2: 188.259,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3565_553",
    x1: 188.259,
    y1: 26,
    x2: 188.259,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3565_553",
    x1: 188.759,
    y1: 37,
    x2: 188.759,
    y2: 171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3565_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 215,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskForTime);
export default __webpack_public_path__ + "static/media/ask_for_time.c7a403947ffb12bebaaf8557a22e8182.svg";
export { ForwardRef as ReactComponent };